export const BILLING_LOG_LABELS = {
  registration: '注册赠送',
  purchase: '点数入账',
  subscription_grant: '订阅逐月赠点',
  admin_adjustment: '后台调账',
  admin_recharge_request: '后台充值',
  referral_bonus: '邀请奖励',
  milestone_bonus: '里程碑奖励',
  redeem_reward: '兑换码奖励',
  spend: '创作消耗',
  consume_script: '剧本生成',
  consume_image: '图片生成',
  consume_video: '视频生成',
  consume_audio: '音频生成',
  consume_review: '剧本审核',
  canvas: '画布生成',
  canvas_refund: '画布任务退点',
  generation_refund: '生成失败退点',
  llm_reservation_refund: '预留积分返还',
  refund: '退款返还',
  purchase_refund_reversal: '购点退款扣回',
  refund_failed_restore: '退款失败返还',
  compensation: '异常补偿',
  expired: '点数过期',
};

export const BILLING_LOG_LABELS_EN = {
  registration: 'Welcome credits',
  purchase: 'Credit purchase',
  subscription_grant: 'Monthly subscription grant',
  admin_adjustment: 'Admin adjustment',
  admin_recharge_request: 'Admin recharge',
  referral_bonus: 'Referral reward',
  milestone_bonus: 'Milestone reward',
  redeem_reward: 'Redeem code reward',
  spend: 'Creation usage',
  consume_script: 'Script generation',
  consume_image: 'Image generation',
  consume_video: 'Video generation',
  consume_audio: 'Audio generation',
  consume_review: 'Script review',
  canvas: 'Canvas generation',
  canvas_refund: 'Canvas task refund',
  generation_refund: 'Generation refund',
  llm_reservation_refund: 'Unused reserved credits returned',
  refund: 'Refund',
  purchase_refund_reversal: 'Refunded purchase reversal',
  refund_failed_restore: 'Failed refund credit restore',
  compensation: 'Service compensation',
  expired: 'Expired credits',
};

export const USAGE_CATEGORY_META = [
  {
    id: 'writing',
    label: '写作 Agent',
    types: ['consume_script'],
    tone: 'violet',
  },
  {
    id: 'image',
    label: '图片生成',
    types: ['consume_image'],
    tone: 'blue',
  },
  {
    id: 'video',
    label: '视频生成',
    types: ['consume_video'],
    tone: 'rose',
  },
  {
    id: 'audio',
    label: '音频生成',
    types: ['consume_audio'],
    tone: 'amber',
  },
  {
    id: 'review',
    label: '剧本审核',
    types: ['consume_review'],
    tone: 'green',
  },
  {
    id: 'canvas',
    label: '画布综合',
    types: ['canvas'],
    tone: 'slate',
  },
];

export function getBillingLogType(item) {
  // 兼容旧流水及尚未升级的账单接口，无需改写历史账目。
  if (item?.type === 'generation_refund' && item?.note === '写作 AI 服务按实际用量返还预留积分') {
    return 'llm_reservation_refund';
  }
  return item?.type;
}

export function getBillingLogLabel(item, locale = 'zh-CN') {
  if (item?.business_title) return locale === 'en-US' ? item.business_title_en || item.business_title : item.business_title;
  const labels = locale === 'en-US' ? BILLING_LOG_LABELS_EN : BILLING_LOG_LABELS;
  if (item?.type === 'consume_script' && item?.note === '写作 AI 服务积分预留') {
    return locale === 'en-US' ? 'Writing AI credit reservation' : '写作 AI 积分预留';
  }
  if (item?.type === 'consume_script' && item?.note === '写作 AI 服务按实际用量扣除') {
    return locale === 'en-US' ? 'Writing AI usage settlement' : '写作 AI 用量结算';
  }
  return labels[getBillingLogType(item)] || item?.note || (locale === 'en-US' ? 'Credit activity' : '点数变动');
}

export function formatBillingDate(value, options = {}) {
  const locale = options.locale || 'zh-CN';
  if (!value) return locale === 'en-US' ? 'Unknown time' : '时间未知';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return locale === 'en-US' ? 'Unknown time' : '时间未知';
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: options.dateOnly ? undefined : '2-digit',
    minute: options.dateOnly ? undefined : '2-digit',
  });
}

export function filterLogsByDays(logs, days) {
  if (days === 'all') return logs;
  const cutoff = Date.now() - Number(days) * 24 * 60 * 60 * 1000;
  return logs.filter(item => {
    const timestamp = new Date(item.created_at).getTime();
    return Number.isFinite(timestamp) && timestamp >= cutoff;
  });
}

export function getUsageCategory(type) {
  return USAGE_CATEGORY_META.find(category => category.types.includes(type));
}
